import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { messages } from '../../../messages';
// This action will not be enabled by default for smart cards, which is opposite of the default behavior for actions.
// The AutomationAction will only appear if product/resourceType combination is handled by this function.
var getProductData = function getProductData(meta) {
  var _ProductData$product;
  var tenantId = meta.tenantId;
  var product = meta.product;
  var resourceType = meta.resourceType;
  var ProductData = {
    'confluence': {
      'page': {
        //TODO extract to server
        siteAri: "ari:cloud:confluence::site/".concat(tenantId),
        //TODO Move to AutomationAction
        modalTitle: messages.automation_action_confluence_page_modal_title,
        modalDescription: messages.automation_action_confluence_page_modal_description
      }
    }
  };
  return ProductData === null || ProductData === void 0 || (_ProductData$product = ProductData[product]) === null || _ProductData$product === void 0 ? void 0 : _ProductData$product[resourceType];
};
export var extractAutomationAction = function extractAutomationAction(response) {
  if (!getBooleanFF('platform.linking-platfom.smart-card.confluence.page.automation-action_xcdoi') || !response.data) {
    return undefined;
  }
  var data = response.data;
  var meta = response.meta;
  var name = data.name,
    objectAri = data["atlassian:ari"];
  var productData = getProductData(meta);
  if (!productData) {
    return undefined;
  }
  return _objectSpread(_objectSpread({}, productData), {}, {
    objectName: name,
    objectAri: objectAri,
    // TODO: The admin experience will be a follow up
    canManageAutomation: false,
    baseAutomationUrl: '',
    analyticsSource: 'smartCard'
  });
};